export default "__VITE_ASSET__af71d6b2__"